import {lazyRegister} from '@/Core/lazyRegister';
import {BaseApiFactory} from "@/Factories/BaseApiFactory";
import {BackgroundJob} from "@/models";

export class BackgroundJobStatusService {
    static readonly $inject = ['BaseApiFactory'];

    constructor(private baseApiFactory: BaseApiFactory) {
    }

    public GetBackgroundJobStatus(id: string) {
        return this.baseApiFactory.getData<BackgroundJob>(`/api/BackgroundJobStatus/track/${id}`);
    }

    public GetBackgroundJobs(query: {
        type: string;
        isActive: boolean;
    }){
        return this.baseApiFactory.getData<BackgroundJob[]>('/api/BackgroundJobStatus', query);
    }
}

lazyRegister.service('BackgroundJobStatusService', BackgroundJobStatusService);
